/* External dependencies */
import { Div, Text } from 'atomize';
import React, { CSSProperties, ReactNode } from 'react';

export interface MenuItemData {
  name: string;
  parentName: string;
  textStyle?: CSSProperties;
  index?: number;
}

export interface MenuItemProps extends MenuItemData {
  suffix: (item: any) => ReactNode;
}

export function MenuItem(props: MenuItemProps) {
  const { name, parentName, index, textStyle, suffix } = props;

  return (
    <Div
      d="flex"
      align="center"
      justify="space-between"
      bg="table_cell_background"
      p={{ y: '5px', x: '5px' }}
      rounded="6px"
      minW="80px"
      w="100%"
      style={{ gap: '10px' }}
      data-testid={`menu-item-${name}`}
    >
      <Div d="flex" w="100%" h="100%">
        <Text
          textSize="15px"
          textColor="table_cell_text_color"
          style={textStyle}
        >
          {name}
        </Text>
      </Div>

      {suffix({ parentName, name, index })}
    </Div>
  );
}
